import { render, staticRenderFns } from "./NavButton.vue?vue&type=template&id=6e8061ba&scoped=true"
import script from "./NavButton.vue?vue&type=script&lang=js"
export * from "./NavButton.vue?vue&type=script&lang=js"
import style0 from "./NavButton.vue?vue&type=style&index=0&id=6e8061ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8061ba",
  null
  
)

export default component.exports